import { createContext } from 'react';
export const FilterHidingContext = createContext({
    registerFilter: () => console.warn(`I'm "registerFilter" from FilterHidingContext, trust me`),
    hasFilterBar: false,
    toggleVisible: () => console.warn(`I'm "toggleVisible" from FilterHidingContext, trust me`),
    isVisible: false,
});
